var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"burger"}},[_c('button',{staticClass:"data-menu-toggle",class:_vm.flg ? 'active':'',attrs:{"id":"data-menu-toggle"},on:{"click":function($event){return _vm.change(_vm.flg)}}},[_c('span',{staticClass:"menu-bar bar"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78bd9410","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BurgerNav.vue
// module id = null
// module chunks = 